import { FC } from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, ButtonBase } from '@mui/material';
import {
  dailyNavRecordNeedsReview,
  getDailyNavStatusLabel,
} from 'pages/Intelligence/DailyNav/daily-nav.constants';
import { ReviewPriceCellProps } from './ReviewPriceCell.props';

const NEEDS_REVIEW_COLOR = '#dc2626';
const NEEDS_REVIEW_HOVER_COLOR = '#b91c1c';
const REVIEWED_COLOR = '#94a3b8';
const REVIEWED_HOVER_COLOR = '#64748b';

const ReviewPriceCell: FC<ReviewPriceCellProps> = ({ row, onReviewClick, canReview }) => {
  const needsReview = dailyNavRecordNeedsReview(row.record);
  const label = getDailyNavStatusLabel(row.record.status);

  const baseColor = needsReview ? NEEDS_REVIEW_COLOR : REVIEWED_COLOR;
  const activeHoverColor = needsReview ? NEEDS_REVIEW_HOVER_COLOR : REVIEWED_HOVER_COLOR;
  const hoverColor = canReview ? activeHoverColor : baseColor;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <ButtonBase
        id={`review-price-button-${row.companyId}`}
        disabled={!canReview}
        onClick={canReview ? () => onReviewClick(row) : undefined}
        sx={{
          alignItems: 'center',
          backgroundColor: baseColor,
          borderRadius: '4px',
          color: '#fff',
          cursor: canReview ? 'pointer' : 'default',
          display: 'inline-flex',
          fontSize: 10,
          fontWeight: 600,
          gap: '4px',
          height: 18,
          lineHeight: 1,
          padding: '2px 8px',
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: hoverColor,
          },
        }}>
        {needsReview && <WarningAmberIcon sx={{ fontSize: 11 }} />}
        {label}
      </ButtonBase>
    </Box>
  );
};

export default ReviewPriceCell;
